import amplitude from 'amplitude-js'
import { getUserSession } from './getUserSession.helper'

class AmplitudeService {
  private getUserInformation() {
    return getUserSession()
  }

  private getUserEnterprise() {
    const { enterprise } = this.getUserInformation() || {}

    return enterprise
  }

  getAmplitudeInstance() {
    const { name } = this.getUserEnterprise() || {}
    const apiKey = this.getApiKey()
    const instanceClient = amplitude.getInstance(
      (apiKey !== process.env.REACT_APP_AMPLITUDE_KEY && name) || 'rankmi_app'
    )
    return instanceClient
  }

  getUserId() {
    const { id } = this.getUserInformation() || {}

    return `${id}`
  }

  getApiKey() {
    return process.env.REACT_APP_AMPLITUDE_KEY || ''
  }

  init() {
    const instanceClient = this.getAmplitudeInstance()
    const userId = this.getUserId()
    const apiKey = this.getApiKey()
    instanceClient.init(apiKey, userId)
  }
}

export default new AmplitudeService()
